import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function getActionSummary(alertType) {
  try {
    const responseDataText = await authenticatedFetch(`${URL.actionSummaryApi}/${alertType}`, {
      method: "GET",
    });

    return responseDataText;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}